import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  removeDocumentById,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformLoginDevice } from './login-devices.transformers';
import type { LoginDevicesCollection } from './login-devices.types';

const PAYLOAD_TYPE = 'loginDevices';

export function loginDevicesReducer(
  state: CollectionStateSlice<LoginDevicesCollection> = {},
  action: CollectionActions<LoginDevicesCollection>,
): CollectionStateSlice<LoginDevicesCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === PAYLOAD_TYPE) {
        const { result, ref, order } = action.payload;
        return mergeDocuments<LoginDevicesCollection>(
          state,
          transformIntoDocuments(result.devices, transformLoginDevice),
          order,
          ref,
        );
      }
      return state;
    }

    case 'API_DELETE_SUCCESS': {
      if (action.payload.type === 'loginDevices') {
        const { originalDocument, ref } = action.payload;
        return removeDocumentById<LoginDevicesCollection>(
          ref,
          state,
          originalDocument.id,
        );
      }

      return state;
    }

    default:
      return state;
  }
}
